<script setup lang="ts">
import { throttle } from 'throttle-debounce'

const route = useRoute()
const { isMobile } = useResponsive()

const isVisible = ref(false)

const isCategoryPage = computed(() => {
  return (
    String(route.name).includes('category') ||
    String(route.name).includes('delivery-slug')
  )
})

const isBasketPage = computed(() => {
  return String(route.name).includes('basket')
})

const isConstructorsPage = computed(() => {
  return route.path === '/make-wok/' || route.path === '/halves/'
})

const isVisibleButton = computed(() => {
  return isVisible.value && !isBasketPage.value && !isConstructorsPage.value
})

const onClick = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' })
}

const onScroll = throttle(300, () => {
  isVisible.value = window.scrollY >= window.innerHeight
})

onMounted(() => {
  window.addEventListener('scroll', onScroll)
})

onBeforeUnmount(() => {
  window.removeEventListener('scroll', onScroll)
})
</script>

<template>
  <client-only>
    <transition name="ui-bounce">
      <div
        v-if="isVisibleButton"
        class="app-scroll-up"
        :class="{ 'app-scroll-up--category': isCategoryPage }"
      >
        <the-button
          class="app-scroll-up__button"
          variant="quaternary"
          radius="lg"
          size="sm"
          icon="expand-up"
          :icon-size="isMobile ? 24 : 40"
          @click="onClick"
        />
      </div>
    </transition>
  </client-only>
</template>

<style scoped lang="scss">
.app-scroll-up {
  position: fixed;
  right: 20px;
  bottom: calc(116px + env(safe-area-inset-bottom, 0px));
  z-index: 1000;
  width: 44px;
  height: 44px;

  @include media('>=phone-md') {
    bottom: calc(106px + env(safe-area-inset-bottom, 0px));
  }

  &--category {
    bottom: calc(164px + env(safe-area-inset-bottom, 0px));
  }

  @include media('>=desktop-mini') {
    right: auto;
    bottom: 20px;
    left: 20px;
    width: 60px;
    height: 60px;
  }

  &__button {
    width: 100%;
    height: 100%;
    background-color: var(--ui-color-peach-transparent) !important;
  }
}
</style>
